import { $t } from '@/app-bootstrapping/SetUpInternationalization'

export enum FilterTypes {
  SELECT,
  TOGGLE,
  SINGLE_STRING,
  COMPONENT,
}

export enum FilterGroups {
  Default = $t('General Filters'),
  Details = $t('Additional Filters'),
  Requirements = $t('Requirements'),
  NoGroup = 'NoGroup', // Won't be part of any group and will appear last
}
